var React = require('react');

function IconCheckBulletPoint (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"16","height":"16","rx":"8","fill":"#19222A","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.54557 9.73857L11.5361 4.74807C11.7254 4.55873 12.0324 4.55873 12.2217 4.74807C12.4111 4.93742 12.4111 5.24441 12.2217 5.43375L6.88841 10.7671C6.69906 10.9564 6.39207 10.9564 6.20273 10.7671L3.77848 8.34284C3.58914 8.1535 3.58914 7.84651 3.77848 7.65716C3.96783 7.46782 4.27482 7.46782 4.46416 7.65716L6.54557 9.73857Z","fill":"white","key":1})]);
}

IconCheckBulletPoint.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = IconCheckBulletPoint;

IconCheckBulletPoint.default = IconCheckBulletPoint;
